<div>
  <h2 mat-dialog-title>Kalender</h2>
  <mat-dialog-content>
    <app-full-calendar [storeId]="data.storeId" [showHeader]="false" [showLegend]="false" [viewDate]="data.selectedDate" [currentSendoutId]="data.sendoutId" [mode]="'select-date'" (dateSelected)="handleDateSelected($event)"></app-full-calendar>
  </mat-dialog-content>
  <mat-dialog-actions>
    <span style="flex: 1 0 auto;"></span>
    <button mat-button [mat-dialog-close]="{confirmed: false}">Annuler</button>
  </mat-dialog-actions>
</div>
